import * as Yup from "yup";
import React from "react";
import { Button } from "@mui/material";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { setPart3PageDirection } from "../../../Actions";

const initialState = {
  courseContent: [],

  skillId: "",
  courseDuration: "",
  hoursPerDay: "",
  files: [],
  cacCertFileName: "",

  filePreviewIsOpen: false,
  backOrNext: ""
};

const formValidationSchema = Yup.object().shape({
  centerCapacity: Yup.number()
    .integer()
    .required("This is a required field")
    .typeError("Please enter a valid number"),
  commentOnConduciveness: Yup.string().required("This is a required field"),
  commentOnDispute: Yup.string().required("This is a required field"),

  commentOnImpact: Yup.string().required("This is a required field"),
  commentOnCurriculum: Yup.string().required("This is a required field"),
  otherInformation: Yup.string().required("This is a required field"),
});

const reducer = (state, action) => {
  switch (action.type) {
    case "changedSkillArea": {
      return {
        ...state,
        skillId: action.body,
      };
    }
    case "changedCourseDuration": {
      return {
        ...state,
        courseDuration: action.body,
      };
    }
    case "changedHoursPerDay": {
      return {
        ...state,
        hoursPerDay: action.body,
      };
    }
    case "addedCourseContentAssessment": {
      const curList = state.courseContent;
      curList.push({
        skillId: action.body.skillId,
        courseDuration: action.body.courseDuration,
        hoursPerDay: action.body.hoursPerDay,
      });

      return {
        ...state,
        courseContent: curList,
      };
    }
    case "deletedCourseContentAssessment": {
      const curList = state.courseContent;
      const newList = curList.toSpliced(action.body, 1);

      return {
        ...state,
        courseContent: newList,
      };
    }
    case "syncLocalStore": {
      return {
        ...state,
        ...action.body,
      };
    }
    case "uploadedFile": {
      const newFileList = [...state.files, action.body];

      return {
        ...state,
        files: newFileList,
      };
    }
    case "uploadedCacCert": {
      const newFileList = [...state.files, action.body];

      return {
        ...state,
        files: newFileList,
        cacCertFileName: action.body.fileName,
      };
    }
    case "uploadedOwnerPassport": {
      const newFileList = [...state.files, action.body];

      return {
        ...state,
        files: newFileList,
      };
    }
    case "removedUploadedCAC": {
      const filteredFileList = state.files.filter(
        (file) => file.fileName !== state.cacCertFileName
      );
      console.log("Removed CAC", filteredFileList);

      return {
        ...state,
        files: filteredFileList,
        cacCertFileName: "",
      };
    }
    case "removedOtherUploadedFiles": {
      const filteredFileList = state.files.filter(
        (file) => file.fileName !== action.body
      );
      console.log("Removed other docs", filteredFileList);

      return {
        ...state,
        files: filteredFileList,
      };
    }
    case "openedFilePreview":
      return {
        ...state,
        filePreviewIsOpen: true,
      };
    case "closedFilePreview":
      return {
        ...state,
        filePreviewIsOpen: true,
      };
    case "pageBack": return {
      ...state,
      backOrNext: "back"
    }
    case "pageNext": return {
      ...state,
      backOrNext: "next"
    }
    default:
      break;
  }
};

const SubmitButtonTR = ({ children, ...otherProps }) => {
  const dispatch = useDispatch();
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    submitForm();
    dispatch(setPart3PageDirection("next"))
  };

  const configButton = {
    variant: "contained",
    color: "primary",
    onClick: handleSubmit,
    ...otherProps
  };

  return (
    <Button {...configButton}>
      {children}
    </Button>
  )
}

const BackButtonTR = ({ children, ...otherProps }) => {
  const dispatch = useDispatch();
  const { submitForm } = useFormikContext();

  const handleSubmit = () => {
    submitForm();
    dispatch(setPart3PageDirection("back"))
  };

  const configButton = {
    variant: "normal",
    color: "primary",
    onClick: handleSubmit,
    ...otherProps
  };

  return (
    <Button {...configButton}>
      {children}
    </Button>
  )
}

export {
  initialState,
  formValidationSchema,
  reducer,
  BackButtonTR,
  SubmitButtonTR
}